import { queryKeys } from '@/lib/query-keys';
import { storage } from '@/lib/storage';
import { apiError, authClient } from '@/lib/api/ts-rest';
import { decodeAccessToken } from '@/lib/auth/token';
import { createLogger } from '@/lib/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const log = createLogger('useMfaVerify');

export const useMfaVerify = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: { challengeId: string; code: string }) => {
      const res = await authClient.verifyMfa({ body: data });
      if (res.status !== 200)
        throw apiError(res, 'Code invalide ou expiré');
      return res.body;
    },
    onSuccess: (data) => {
      log.info('MFA verification successful');
      storage.set('accessToken', data.accessToken);
      storage.set('refreshToken', data.refreshToken);

      const tokenPayload = decodeAccessToken(data.accessToken);
      if (!tokenPayload) {
        log.error('MFA verification succeeded but the access token is unreadable');
        toast.error('Connexion impossible. Veuillez réessayer.');
        return;
      }
      storage.set('tenantSlug', tokenPayload.tenantSlug);

      queryClient.invalidateQueries({ queryKey: queryKeys.auth.user() });

      navigate(`/o/${tokenPayload.tenantSlug}/home`, { replace: true });
    },
    onError: (error: Error) => {
      log.error('MFA verification failed', error);
      toast.error(
        error.message || 'Code invalide ou expiré. Veuillez réessayer.'
      );
    },
  });

  return {
    verifyMfa: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};
